// extracted by mini-css-extract-plugin
export var project_gallery = "ProjectGallery-module--project_gallery--93Ipa";
export var project_gallery_title = "ProjectGallery-module--project_gallery_title--OUTZH";
export var project_gallery_image = "ProjectGallery-module--project_gallery_image--81nCI";